import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { IAuthState } from "./auth";
import { IQRScannerState } from "./qrscanner";
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IRootState {
  auth: IAuthState;
  qrscanner: IQRScannerState;
}

export default new Vuex.Store<IRootState>({});
